import { Component, ViewChild, ElementRef, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Venue } from '../venues';
import { VenuesService } from '../venues.service';

declare const google: any;

@Component({
    selector: 'app-new-venue',
    templateUrl: './new-venue.component.html',
    styleUrls: ['./new-venue.component.scss'],
    standalone: false
})
export class NewVenueComponent implements OnInit {
  @ViewChild('search', { static: false })
  public searchElementRef: ElementRef;

  venue = new Venue();
  added = false;
  options = {
    types: ['address'],
    componentRestrictions: {country: 'us'}
  };

  constructor(
    public modalRef: BsModalRef,
    private venueService: VenuesService
  ) {}

  ngOnInit() {}

  ngAfterViewInit() {
    const input = document.getElementById('address-input');
    const autocomplete = new google.maps.places.Autocomplete(input, {
      types: ['address'],
      componentRestrictions: { country: 'us' }
    });
    autocomplete.addListener('place_changed', () => {
      const place = autocomplete.getPlace();
      this.onLocationSelected(place);
    });
  }

  onLocationSelected(event: any) {
    this.venue.latitude = event.geometry.location.lat();
    this.venue.longitude = event.geometry.location.lng();
  }

  addVenue() {
    this.venueService.create(this.venue).subscribe(
      (response) => {
        this.added = true;
        this.modalRef.hide();
        this.venueService.formatVenue(response['data']);
        this.venue.setData(response['data']);
      },
      () => {
        this.modalRef.hide();
      });
  }
}
